import angular from 'angular';

import { originalAccount } from 'redevConfig';

const detail = (originalAccount && originalAccount.detail) || '';
const originalAccountList =
  (originalAccount && originalAccount.originalAccountList) || '';
const customsPaymentList =
  (originalAccount && originalAccount.customsPaymentList) || '';
const listPage = require('./views/originalAccountListBanner.html');
const originalAccountListBannerCtrl = require('./originalAccountListBannerCtrl');

const managementDetail = detail
  ? require(`redevelopment/input/originalAccount/${detail.templateName}`)
  : require('../../inputInvoice/management/view/managementDetail.html');

const originalAccountListPage = originalAccountList
  ? require(`redevelopment/input/originalAccount/${originalAccountList.templateName}`)
  : require('./views/originalAccountList.html');
const originalAccountListCtrl = originalAccountList
  ? require(`redevelopment/input/originalAccount/${originalAccountList.controllerName}`)
  : require('./originalAccountListCtrl');
const customsPaymentListPage = customsPaymentList
  ? require(`redevelopment/input/originalAccount/${customsPaymentList.templateName}`)
  : require('./views/customsPaymentListPage.html');
const customsPaymentListCtrl = customsPaymentList
  ? require(`redevelopment/input/originalAccount/${customsPaymentList.controllerName}`)
  : require('./customsPaymentListCtrl');

export default angular
  .module('input.specialInvoiceCertification.originalAccount', [])
  .config([
    '$stateProvider',
    function config($stateProvider) {
      $stateProvider
        .state('input.certification.originalAccount', {
          url: '/originalAccount',
          abstract: true,
          template: '<div ui-view></div>',
          title: '电子底账管理',
          default: 'input.certification.originalAccount.list',
        })
        .state('input.certification.originalAccount.list', {
          url: '/list',
          template: listPage,
          controller: 'originalAccountListBannerCtrl',
        })
        .state('input.certification.originalAccount.detail', {
          url: '/detail/:object',
          template: managementDetail,
          controller: 'managementDetailCtrl',
          title: '电子底账详情',
        });
      // }]).controller('originalAccountListCtrl', originalAccountListCtrl.default)
    },
  ])
  .controller(
    'originalAccountListBannerCtrl',
    originalAccountListBannerCtrl.default
  )
  .controller('originalAccountListCtrl', originalAccountListCtrl.default)
  .controller('customsPaymentListCtrl', customsPaymentListCtrl.default)
  .component('originalAccount', {
    template: originalAccountListPage,
    controller: 'originalAccountListCtrl',
  })
  .component('customsPayment', {
    template: customsPaymentListPage,
    controller: 'customsPaymentListCtrl',
  }).name;



// WEBPACK FOOTER //
// ./src/app/input/specialInvoiceCertification/originalAccount/index.js